export const Colors = {
  grayDark: '#333333',
  lightBlue: '#0071BC',
  paginationItemColor: '#EDEDED',
  filterIcon: '#A1A0A0',
};
